import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axios";

export const getCalendarBlocks = createAsyncThunk(
  "booking/getCalendarBlocks",
  async ({ venue_id, year, month }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (venue_id) params.append("venue_id", venue_id);
      if (year) params.append("year", year);
      if (month) params.append("month", month);
      const { data } = await api.get(`/api/vendor/bookings/calendar-blocks?${params}`);
      return data.data;
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || e.message);
    }
  }
);

export const manageCalendarBlock = createAsyncThunk(
  "booking/manageCalendarBlock",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/vendor/bookings/calendar-blocks", payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || e.message);
    }
  }
);

const bookingSlice = createSlice({
  name: "booking",
  initialState: {
    calendarBlocks: { data: [], loading: false, error: null },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCalendarBlocks.pending, (state) => {
        state.calendarBlocks.loading = true;
        state.calendarBlocks.error = null;
      })
      .addCase(getCalendarBlocks.fulfilled, (state, action) => {
        state.calendarBlocks.loading = false;
        state.calendarBlocks.data = action.payload;
      })
      .addCase(getCalendarBlocks.rejected, (state, action) => {
        state.calendarBlocks.loading = false;
        state.calendarBlocks.error = action.payload;
      })
      .addCase(manageCalendarBlock.fulfilled, (state) => {
        // Trigger re-fetch in component
      });
  },
});

export const selectCalendarBlocks = (s) => s.booking.calendarBlocks;

export default bookingSlice.reducer;
